import {get} from '../apiService'
export const getAdvertiserList=(limit,offset,sort)=>{
  return get(`/advertiser/?limit=${limit}&offset=${offset}${sort?sort:''}`)
}
export const getAdvertiser=(id)=>{
  return get(`/advertiser/${id}`)
}